module.exports = __webpack_public_path__ + "static/media/02.a4b01d62.jpg";